<template>
  <div>
    <menu-panel raiz="/comerciante/" :vistas="Vistas" @on-log-out="logOut()" />
    <router-view></router-view>
  </div>
</template>
<script>
import { AuthFacade as Facade } from "../../service/comerciante/auth/auth.facade";

import MenuPanel from "../../components/panel/MenuPanel.vue";
import {
  RouteNames,
  VistasMenuPanel
} from "../../routes/comerciante.routes.js";

export default {
  components: { MenuPanel },
  computed: {
    Vistas() {
      return VistasMenuPanel;
    }
  },
  methods: {
    logOut() {
      try {
        Facade.logOut();
      } catch (error) {
        console.error(error);
      }

      this.$router.push({ name: RouteNames.logIn });
    }
  }
};
</script>